export default "__VITE_ASSET__BMRTXJg3__"